import {
    SEND_COMMAND_OPEN_MODAL,
    SEND_COMMAND_CLOSE_MODAL,
    SEND_COMMAND_GET_DEVICE_REQUEST,
    SEND_COMMAND_GET_DEVICE_RESULT,
    SEND_COMMAND_REQUEST,
    SEND_COMMAND_RESULT,
    SEND_COMMAND_SET_DEVICES,
    SEND_COMMAND_SEARCH_DEVICE_MODEL_REQUEST,
    SEND_COMMAND_SEARCH_DEVICE_MODEL_RESULT,
    SEND_COMMAND_SEARCH_COMMANDS_REQUEST,
    SEND_COMMAND_SEARCH_COMMANDS_RESULT,
    SEND_COMMAND_SEARCH_MASS_COMMANDS_REQUEST,
    SEND_COMMAND_SEARCH_MASS_COMMANDS_RESULT,
    SEND_COMMAND_GET_DETAILS_REQUEST,
    SEND_COMMAND_GET_DETAILS_RESULT,
    SEND_COMMAND_GENERAL_REQUEST,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    device: null,
    devices: [],
    deviceModels: null,
    commands: [],
    massCommandGroups: {
        manufacturer: null,
        unitTypes: [],
        deviceModels: [],
    },
    detailsResult: [],
    massSMS: false
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case SEND_COMMAND_SEARCH_COMMANDS_REQUEST:
            return { ...state, loading: true }

        case SEND_COMMAND_SEARCH_COMMANDS_RESULT:
            return { ...state, loading: false, commands: action.payload }

        case SEND_COMMAND_SEARCH_MASS_COMMANDS_REQUEST:
            return {
                ...state,
                loading: true,
                massCommandGroups: INIT_STATE.massCommandGroups,
            }

        case SEND_COMMAND_SEARCH_MASS_COMMANDS_RESULT:
            return { ...state, loading: false, massCommandGroups: action.payload || INIT_STATE.massCommandGroups }

        case SEND_COMMAND_SEARCH_DEVICE_MODEL_REQUEST:
            return { ...state, loading: true }

        case SEND_COMMAND_SEARCH_DEVICE_MODEL_RESULT:
            return { ...state, loading: false, deviceModels: action.payload }

        case SEND_COMMAND_SET_DEVICES:
            return { ...state, devices: action.payload || [] }

        case SEND_COMMAND_OPEN_MODAL:
            return { ...state, openModal: true, devices: action.payload?.selectedDevices || [], massSMS: action.payload?.massSMS || false }

        case SEND_COMMAND_CLOSE_MODAL:
            return { ...state, openModal: false }

        case SEND_COMMAND_GET_DEVICE_REQUEST:
            return { ...state, loading: true }

        case SEND_COMMAND_GET_DEVICE_RESULT:
            return { ...state, loading: false, device: action.payload }

        case SEND_COMMAND_REQUEST:
            return { ...state, loading: true }

        case SEND_COMMAND_RESULT:
            return { ...state, loading: false, result: action.payload }

        case SEND_COMMAND_GET_DETAILS_REQUEST:
            return { ...state, loading: true }

        case SEND_COMMAND_GET_DETAILS_RESULT:
            return { ...state, loading: false, detailsResult: action.payload }

        case SEND_COMMAND_GENERAL_REQUEST:
            return { ...state, loading: true }

        case CLEAR_REDUX:
            return ["", "SEND_COMMAND"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};